







import * as _ from 'lodash';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import $ from 'jquery';
import LockedScreen from './screens/LockedScreen.vue';
import HomeScreen from './screens/HomeScreen.vue';
import { Language, VisitorType } from '../../types/Enum';

@Component({
  components: {
    LockedScreen,
    HomeScreen,
  },
})
export default class MobileGesture extends Vue {
    private isLocked: boolean = true;

    private start: boolean = false;

    public mounted() {
      this.$root.$on('App::Animation::End', () => {
        this.start = true;
      });
      this.$root.$on('LockedScreen::Unlock', () => {
        alert('event received !');
        this.isLocked = false;
      });
      this.$root.$on('LockedScreen::lock', () => {
        this.isLocked = true;
      });
    }
}
